
<template>
  <div>
    <v-card flat>
      <v-card-text>
        <div class="d-flex justify-end">
          <v-btn @click="goToCreateBuildingPage" small class="primary mt-2">
            <v-icon left small>mdi-office-building-plus-outline</v-icon>
            <span>Cadastrar obra</span>
          </v-btn>
        </div>
        <card-loading-transparent v-if="loading"></card-loading-transparent>
        <v-list v-if="!loading" two-line>
          <template v-for="(building, index) in buildings">
            <v-list-item ripple>
              <v-list-item-icon>
                <v-icon>mdi-domain</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text--primary">
                  {{building.attributes?.name}}
                </v-list-item-title>
                <v-list-item-subtitle>{{building.attributes?.full_address}}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn small icon class="primary" @click="goToEditBuildingPage(building.id)">
                  <v-icon small class="white--text">mdi-pencil</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-list>
        <v-alert v-if="!loading && buildings.length == 0" dense border="left" :value="true" type="warning">Nenhuma obra cadastrada</v-alert>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';
import cimentao_links from "@/mixins/cimentao_links";

export default {
  name: 'ShowClientBuildings',
  props:{
    client_id:{
      type: [Number,String]
    }
  },
  mixins: [cimentao_links ],
  data() {
    return {
      loading: false,
      buildings: [],
    }
  },
  methods: {
    getData() {
      this.getBuildings()
    },
    goToCreateBuildingPage(){
      this.URL_MAP[2].function(`${this.URL_MAP[2].link}buildings/create`)
    },
    goToEditBuildingPage(id){
      this.URL_MAP[2].function(`${this.URL_MAP[2].link}buildings/${id}`)
    },
    getBuildings() {
      if(this.client_id){
        this.loading = true 
        Api.Building.index({client_id:this.client_id}).then(res => {
          this.buildings = [...res.data.data]
        }).catch(()=>{
  
        }).finally(()=>{
          this.loading = false
        })
      }
    },
  },
  mounted(){
    this.getData()
  },
  watch:{
    client_id(nv){
      if(nv){
        this.getBuildings()
      }
    }
  }

}
</script>